<template>
  <div>
    <b-container>
      <h5>
        Occupy an appointment for the timeslot: {{ timeslot }}
      </h5>
      <label for="id-input-name">Name *: </label>
      <b-form-input
        id="id-input-name"
        class="form-control"
        v-model="formData.appt.name"
        placeholder="Name"
        required
        :state="validName"
        :disabled="isAdmin && isOccupied" />
      <label for="id-input-email">Email *: </label>
      <b-form-input
        id="id-input-email"
        class="form-control is-valide"
        v-model="formData.appt.email"
        placeholder="eMail"
        :state="validEmail"
        :disabled="isAdmin && isOccupied" />
      <div v-if="!hasOccasionsList() || (isAdmin && isOccupied)">
        <label for="id-input-title">Title *: </label>
        <b-form-input
          id="id-input-title"
          class="form-control"
          v-model="formData.appt.title"
          placeholder="Occasion"
          :state="validTitle"
          :disabled="isAdmin && isOccupied" />
      </div>
      <div v-else>
        <div>
          <label for="id-select-occasion">Occasion *: </label>
        </div>
        <b-form-select
          id="id-select-occasion"
          class="custom-select"
          v-model="formData.occasionSelected"
          :state="validOccasion"
          @change="handleSelectOccasionChange()">
          <b-form-select-option disabled value="null">Please select one</b-form-select-option>
          <b-form-select-option
            v-for="(opt, ndx) in occasionsList"
            :key="ndx"
            :value="ndx">{{ opt }}</b-form-select-option>
        </b-form-select>
      </div>
      <div v-if="hasPaymentsList() && !isOccupied">
        <label for="id-input-price">Price: {{ getSelOccasionPrice() }}</label>
      </div>
      <div v-if="hasPaymentsList() && isOccupied">
        <label for="id-input-price">Payment order: currently available only on the dashboard</label>
      </div>
      <label for="id-textarea-description">Description *: </label>
      <textarea
        id="id-textarea-description"
        class="form-control"
        v-model="formData.appt.descr"
        placeholder="Enter description ..."
        rows="3"
        max-rows="6"
        :disabled="isAdmin && isOccupied" />
    </b-container>
  </div>
</template>

<script>
const DEFAULT_APPT = { title: '', descr: '', name: '', email: '' }

export default {
  name: 'ts-appt',
  version: '0.0.1',
  props: {
    timeslot: {
      type: String,
      required: true
    },
    occasionsList: {
      type: Array,
      default: () => []
    },
    paymentsList: {
      type: Array,
      default: () => []
    },
    apptData: {
      type: Object,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    isOccupied: {
      type: Boolean,
      default: false
    }
  }, // props
  components: {}, // components
  data () {
    return {
      loaded: false,
      formData: {
        occasionSelected: null,
        appt: this.apptData ?? Object.assign({}, DEFAULT_APPT)
      }
    }
  }, // data
  /* ----- vuejs hooks ----- */
  mounted () {}, // mounted
  computed: {
    validName: function () {
      return this.formData.appt.name?.length > 1 &&
        this.formData.appt.name?.length < 20
    }, // validName
    validEmail: function () {
      const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b$/i
      return re.test(this.formData.appt.email)
    }, // validEmail
    validTitle: function () {
      return this.formData.appt.title?.length > 1 &&
        this.formData.appt.title?.length < 20
    }, // validTitle
    validOccasion: function () {
      return this.formData?.occasionSelected >= 0
    }, // validOccasion
    validFormData: function () {
      return this.validName && this.validEmail && this.validTitle && this.validOccasion
    } // validFormData
  }, // computed
  watch: {
    validFormData: function () {
      this.$emit('valid-form-data-changed', this.validFormData)
    }
  }, // watch
  methods: {
    /* ----- public methods ----- */
    isValidFormData () {
      return this.validName && this.validEmail &&
        (this.validTitle || this.validOccasion)
    }, // isValidFormData
    getFormData () {
      const _fd = {}
      _fd.appt = Object.assign({}, this.formData.appt)
      _fd.appt.descr = this.sanitize(this.formData.appt.descr.substr(0, 90))
      if (_fd.appt.title?.length <= 0) {
        _fd.appt.title = this.occasionsList[this.formData.occasionSelected]
      }
      if (this.hasPaymentsList() && (this.formData.occasionSelected ?? -1) >= 0) {
        _fd.appt.paymAmount = this.paymentsList[this.formData.occasionSelected]
      }
      // console.log('TRACE-REMOVE: TSAppt.getFormData: _fd is : ', _fd)
      return _fd
    }, // getFormData
    /* ----- handler methods ----- */
    handleSelectOccasionChange () {
      this.formData.appt.title = this.occasionsList[this.formData.occasionSelected]
    }, // handleSelectOccasionChange
    /* ----- helper methods ----- */
    getSelOccasionPrice () {
      return this.paymentsList[this.formData.occasionSelected]
    }, // getSelOccasionPrice
    hasPaymentsList () {
      return this.paymentsList.length > 0
    }, // hasPaymentsList
    hasOccasionsList () {
      return this.occasionsList.length > 0
    }, // hasOccasionsList
    sanitize (string) {
      const map = {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#x27;',
          "/": '&#x2F;',
      };
      const reg = /[&<>"'/]/ig;
      return string.replace(reg, (match)=>(map[match]));
    } // sanitize
  } // methods
}
</script>

<style lang="scss" scoped>
</style>
